import React, { useEffect, useState } from 'react'
import { IoCheckmarkCircleOutline } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { url } from '../configlink'

function ReferFriend() {
  
    const user = useSelector((state) => state.user.user)
   
    let [formData, setFormData] = useState({
        fromUser: {},
        referUser: {},
    })

    let [referCompeleted, setReferCompeleted] = useState(false)

    let [buttonColor, setButtonColor] = useState(false)


    const [errors, setErrors] = useState({});
    
    const navigate = useNavigate();

    useEffect(() => {
        // console.log('fromUser', user);
        
        setFormData({...formData, fromUser: {
            userId: user.UserId,
            name: `${user.FirstName} ${user.LastName}`,
            email: user.EmailAddress,
            company: user.company,
            pi: user.pinvestigator
        }})
    },[])

    useEffect(() => {
        window.scrollTo(0,100)
    },[])


    const validateForm = () => {
        const newErrors = {};

        if(!formData.referUser.name) newErrors.referUserName = 'Please enter'
        if(!formData.referUser.email) {
            newErrors.referUserEmail = 'Please enter'
        } else if(formData.referUser.email  === formData.fromUser.email) {
            newErrors.referUserEmail = 'Please enter a different email'
        } 
        else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.referUser.email)) {
            newErrors.referUserEmail = 'Please enter a valid email'
        }
        if(!formData.referUser.company) {
            newErrors.referUserCompany = 'Please enter'
        } 
        
		// if(!formData.referUser.pi) newErrors.referUserPi = 'Please enter'
        
        return newErrors
    };

    
    function handleSubmit(){

        const validationErrors = validateForm();
        // console.log("here", validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors)
        }
        else {
            // alert('PASS');
                        
            let data2 = formData
            // console.log(data2);

            setButtonColor(true)

            try {
                fetch(`${url}/api/users/referafriend`, {
                method: "POST",
                credentials: 'include',
                headers: {
                    // Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data2),
                })
                .then(res => res.json())
                .then(data => {
                if(data.message === 'success'){
                    // alert("Success")
                    setReferCompeleted(true)
                }
                else if(data.message === 'exists') {
                    setErrors({...errors, referUserEmail: 'User is already registered with ACGT.'})
                }
                else if(data.message === 'referred') {
                    setErrors({...errors, referUserEmail: 'User has been referred previously.'})
                }
                setButtonColor(false)
                })
            } catch (error) {
                setButtonColor(false)
                console.log(error);
                
            } 
        }
    }
    

  return (
    <>
       <div className=' px-[16px] sm:px-[40px] xl:px-[128px]'>
        <div className="flex flex-col sm:flex-row justify-between items-center my-[40px] gap-[20px]">
          <h1 className='text-center sm:!text-left text-4xl text-[var(--color-primary-purple)] font-black '>
           Refer-a-Friend Program
          </h1>
        </div>
        
        {referCompeleted ? 
            <div className="flex flex-col items-center gap-[10px] mt-10">
                <div className="flex items-center justify-center gap-[8px]">
                    <IoCheckmarkCircleOutline className='h-[36px] w-[36px] text-[#60C5C5]' />
                    <p className="text-center font-bold text-2xl text-[var(--color-primary-purple)]">Thank you for referring a friend!</p>
                </div>
                    <div className="flex flex-col gap-[20px] w-[80%] mt-8">
                        <p className='text-center font-bold text-lg'>You will get the discount code email when the referral is complete. <br/>Should you have any questions please reach out to us at <a className='text-blue-800 underline' href="mailto:dnaseq@acgtinc.com">dnaseq@acgtinc.com</a>.</p>
                    </div>
                <button
                className='mt-12 border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[289px] h-[43px] mb-16'
                onClick={() => navigate('/dashboard')}
                >
                    go back to account home
                </button>
            </div>
            :
            <div>
                <p className='text-2xl font-bold'>Receive a 50% OFF discount when you refer ACGT to a colleague.</p>
                <p className='text-lg mt-2'>When your colleague creates an account and places their first paid order, both of you will receive a discount code for 50% OFF your next Sanger or Whole Plasmid order.</p>
            
                <div className='mt-5 flex flex-col gap-[80px] sm:px-16'>
                    {/* <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Your information</p>
                        <div className='flex items-center gap-[30px]'>
                            <p className='text-lg w-[230px] text-right'>Name:</p>
                            <input 
                            type="text"
                            value={formData.fromUser.name}
                            disabled
                            className='h-10 px-2 border border-1 flex-1 max-w-[400px]'
                            />
                        </div>
                          
                        
                        <div className='flex items-center gap-[30px]'>
                            <p className='text-lg w-[230px] text-right'>Email:</p>
                            <input 
                            type="text"
                            value={formData.fromUser.email}
                            disabled
                            className='h-10 px-2 border border-1 flex-1 max-w-[400px]'
                            />
                        </div>
                           

                        <div className='flex items-center gap-[30px]'>
                            <p className='text-lg w-[230px] text-right'>Company:</p>
                            <input 
                            type="text"
                            value={formData.fromUser.company}
                            disabled
                            className='h-10 px-2 border border-1 flex-1 max-w-[400px]'
                            />
                        </div>
                            

                        <div className='flex items-center gap-[30px]'>
                            <p className='text-lg w-[230px] text-right'>Principal Investigator (PI):</p>
                            <input 
                            type="text"
                            value={formData.fromUser.pi}
                            disabled
                            className='h-10 px-2 border border-1 flex-1 max-w-[400px]'
                            />
                        </div>
                        

                    </div> */}

                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Your colleague&apos;s information</p>
                        <div className='flex items-center gap-[30px]'>
                            <p className='text-lg w-[230px] text-right'>Name<span className='text-red-600'>*</span>:</p>
                            <input 
                            type="text"
                            value={formData.referUser.name}
                            onChange={(e) => {
                                setErrors({...errors, referUserName: ''})
                                setFormData({...formData, referUser: {...formData.referUser, name: e.target.value}})
                            }
                            }
                            className='h-10 px-2 border border-1 flex-1 max-w-[400px]'
                            />
                        </div>
                            {errors.referUserName && (
                                <span className='pl-[260px] text-[14px] text-red-500 font-bold'>{errors.referUserName}</span>
                            )}
                        
                        <div className='flex items-center gap-[30px]'>
                            <p className='text-lg w-[230px] text-right'>Email<span className='text-red-600'>*</span>:</p>
                            <input 
                            type="text"
                            value={formData.referUser.email}
                            onChange={(e) =>  {
                                setErrors({...errors, referUserEmail: ''})
                                setFormData({...formData, referUser: {...formData.referUser, email: e.target.value}})
                            }
                            }
                            className='h-10 px-2 border border-1 flex-1 max-w-[400px]'
                            />
                        </div>
                            {errors.referUserEmail && (
                                <span className='pl-[260px] text-[14px] text-red-500 font-bold'>{errors.referUserEmail}</span>
                            )}

                        <div className='flex items-center gap-[30px]'>
                            <p className='text-lg w-[230px] text-right'>Company<span className='text-red-600'>*</span>:</p>
                            <input 
                            type="text"
                            value={formData.referUser.company}
                            onChange={(e) => {
                                setErrors({...errors, referUserCompany: ''})
                                setFormData({...formData, referUser: {...formData.referUser, company: e.target.value}})
                            }
                            }
                            className='h-10 px-2 border border-1 flex-1 max-w-[400px]'
                            />
                        </div>
                            {errors.referUserCompany && (
                                <span className='pl-[260px] text-[14px] text-red-500 font-bold'>{errors.referUserCompany}</span>
                            )}

                        <div className='flex items-center gap-[30px]'>
							<p className='text-lg w-[230px] text-right'>Principal Investigator (PI):</p>
                            <input 
                            type="text"
                            value={formData.referUser.pi}
                            onChange={(e) => {
                                setErrors({...errors, referUserPi: ''})
                                setFormData({...formData, referUser: {...formData.referUser, pi: e.target.value}})
                            } 
                            }
                            className='h-10 px-2 border border-1 flex-1 max-w-[400px]'
                            />
                        </div>
                            {errors.referUserPi && (
                                <span className='pl-[260px] text-[14px] text-red-500 font-bold'>{errors.referUserPi}</span>
                            )}
                        

                    </div>

                    <div className=''>
                        <p className='text-lg font-bold'>Terms and Conditions:</p>
                        <p>Both the referrer and referral will receive a one-time discount code for 50% OFF upon the referral’s submission of a paid order through a newly created account. The referral cannot have been previously referred. This promotional discount is valid for a single order only for Sanger or Whole Plasmid Sequencing services. Custom NGS projects or regulatory services are not included. Its maximum discount value is no more than $200 and it cannot be combined with any other offer or volume discount contract. Certain institutions prohibit the participation of promotional discount programs, please check with your institutional policies and regulations. These terms and conditions are subject to change at any time without notice. Other restrictions may apply.</p>
                    </div>
     
                    <div className='flex gap-[30px] justify-center sm:justify-start'>
                        <button
                        className={`border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 ${buttonColor? 'bg-[#58595b] pointer-events-none' : 'bg-[#302a7e] '} text-white uppercase min-w-[159px] h-[43px] mb-16`}
                        onClick={() => handleSubmit()}
                        >
                        Submit
                        </button>
                        <button
                        className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[159px] h-[43px] mb-16'
                        onClick={() => navigate('/dashboard')}
                        >
                        Cancel
                        </button>
                    </div>
                </div>
            </div>
        }   
      
      </div>
    </>
    
  )
}

export default ReferFriend